<template>
  <div class="row col-12 q-pa-sm">
    <div class="row col-11 q-my-lg">
      <span class="text-h6 text-brand-5 text-weight-bold texto-titulo">
        Últimas Mudanças de Status
      </span>
    </div>
    <div class="col-12 q-mt-md">
      <q-table
        :columns="columns"
        :rows="pt.logStatus"
        :loading="loading"
        color="primary"
        flat
        style="height: 400px"
        table-header-class="bg-accent text-weight-bold"
        hide-bottom
        virtual-scroll
        class="tabela-tamanho-fixo"
        :rows-per-page-options="[0]"
        dense
        @virtual-scroll="onScroll"
        :virtual-scroll-item-size="48"
        :virtual-scroll-sticky-size-start="48"
      >
        <template v-slot:body-cell-status="props">
          <q-td style="padding: 0; margin: 0" key="status" :props="props">
            <div
              v-if="props.row.status == 'aberto'"
              style="width: fit-content; background: #fefed1; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content; background: #e8ffec"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; background: #fff6e3; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; background: #fefed1; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; background: #f8f8f8; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content; background: #efecec"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.status == 'finalizado'"
              style="width: fit-content; background: #e8ffec; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.status == 'iniciado'"
              style="width: fit-content; background: #ecf1fe; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.status == 'encerrado'"
              style="width: fit-content; background: #f8f8f8; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.status == 'cancelado'"
              style="width: fit-content; background: #efecec; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.status == 'aguardando_assinaturas'"
              style="width: fit-content; background: #fff6e3; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-data="props">
          <q-td :props="props">
            <div>
              {{
                props.row.dataHora.split(" ")[0].split("-").reverse().join("/")
              }}
              <p style="margin: 0 0 0 4px">
                {{ props.row.dataHora.split(" ")[1] }}
              </p>
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
export default {
  setup() {
    const columns = [
      {
        name: "nome",
        label: "Nome Responsável",
        field: "usuarioNome",
        align: "left",
      },
      {
        name: "status",
        label: "Status",
        align: "left",
      },
      {
        name: "data",
        label: "Data da Alteração",
        align: "center",
      },
    ];
    const store = useStore();
    const route = useRoute();
    const pt = ref([]);
    let loading = ref(false);
    const ptId = route.params.ptId;

    const buscarDetalhePt = async () => {
      loading.value = true;
      store.dispatch("pdt/hiddenHeader", true);
      const resposta = await store.dispatch("pdt/buscarDetalhePt", { ptId });
      if (resposta.data.resultado.dados.logStatus) {
        pt.value = resposta.data.resultado.dados;
      }
      loading.value = false;
    };

    const usuarioPodeEditar = computed(() => {
      if (!pt.value) {
        return false;
      }

      return (
        store.getters["autenticacao/usuarioLogado"].id ===
        pt.value.emissorMatricula
      );
    });

    onMounted(buscarDetalhePt);

    return {
      buscarDetalhePt,
      columns,
      pt,
      usuarioPodeEditar,
      loading,
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.titulo-table {
  font-size: 17px;
}

@media (max-width: 600px) {
  .titulo-pagina {
    font-size: 14px;
  }
  .cursor {
    font-size: 14px !important;
    margin-top: 9px !important;
  }
  .titulo-input {
    font-size: 12px;
  }
  .input-text-area {
    font-size: 12px;
  }
  .titulo-table {
    font-size: 13px;
  }
  .btn {
    font-size: 11px;
  }
}
</style>
